import React from 'react';
import { Legacy } from '../components/Legacy';
import { Award, Shield, Users, Target } from 'lucide-react';
export function LegacyPage() {
  return <div className="bg-white" data-id="element-429">
      <div className="bg-slate-50 py-16 border-b border-slate-200" data-id="element-430">
        <div className="max-w-7xl mx-auto px-4 md:px-8" data-id="element-431">
          <h1 className="text-4xl md:text-5xl font-black text-federal-blue mb-4" data-id="element-432">
            Our Legacy
          </h1>
          <p className="text-tech-slate max-w-2xl text-lg opacity-80" data-id="element-433">
            15 years of unwavering commitment to federal excellence and secure
            innovation.
          </p>
        </div>
      </div>

      <Legacy data-id="element-434" />

      <section className="py-16 bg-white" data-id="element-435">
        <div className="max-w-7xl mx-auto px-4 md:px-8" data-id="element-436">
          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8" data-id="element-437">
            {[{
            icon: Shield,
            title: 'Integrity',
            desc: 'Uncompromising adherence to NIST and HIPAA standards.'
          }, {
            icon: Target,
            title: 'Precision',
            desc: 'Mission-focused engineering with zero margin for error.'
          }, {
            icon: Users,
            title: 'Service',
            desc: 'Dedicated support for the men and women in federal service.'
          }, {
            icon: Award,
            title: 'Excellence',
            desc: '15+ years of proven past performance in complex environments.'
          }].map((value, i) => <div key={i} className="text-center p-6" data-id="element-438">
                <div className="w-16 h-16 bg-federal-blue/5 flex items-center justify-center rounded-full mx-auto mb-6" data-id="element-439">
                  <value.icon className="w-8 h-8 text-federal-blue" data-id="element-440" />
                </div>
                <h3 className="text-lg font-bold text-federal-blue mb-2" data-id="element-441">
                  {value.title}
                </h3>
                <p className="text-sm text-federal-blue opacity-70" data-id="element-442">
                  {value.desc}
                </p>
              </div>)}
          </div>
        </div>
      </section>

      <section className="py-16 bg-federal-blue text-white" data-id="element-443">
        <div className="max-w-7xl mx-auto px-4 md:px-8 text-center" data-id="element-444">
          <h2 className="text-3xl font-black mb-8" data-id="element-445">
            A Local Partner with Global Standards
          </h2>
          <p className="max-w-3xl mx-auto text-white/70 leading-relaxed mb-12" data-id="element-446">
            Founded in North Carolina and expanded into the Maryland/DC
            corridor, Codes & Cogs has grown from a specialized software shop
            into a full-service federal infrastructure partner. Our journey is
            defined by the trust placed in us by the agencies we serve.
          </p>
          <div className="flex flex-wrap justify-center gap-12 opacity-50 grayscale brightness-200" data-id="element-447">
            <div className="font-black text-2xl tracking-tighter uppercase italic" data-id="element-448">
              Est. 2011
            </div>
            <div className="font-black text-2xl tracking-tighter uppercase italic" data-id="element-449">
              WOSB Certified
            </div>
            <div className="font-black text-2xl tracking-tighter uppercase italic" data-id="element-450">
              NIST Compliant
            </div>
          </div>
        </div>
      </section>
    </div>;
}